import getAlerts from '../scripts/get-alerts';
import getSensors from '../scripts/get-sensors';
import sort from 'array-sort';
import userLoggedIn from '../scripts/user-logged-in'
import UserNotifications from '../components/user-notifications'
import UserNotificationsInstance from '../components/user-notifications'
import Modal from '../scripts/modal'
import serialize from 'form-serialize'
import isAccountReadOnly from '../scripts/is-account-read-only'
import downloadNotifications from '../scripts/download-notifications'
import prettyPrintKey from '../scripts/pretty-print-key'
import { isUndefined } from 'underscore'
import Branding from '../components/branding'
import maybeBlacklistedOverlay from '../components/maybe-blacklisted-overlay'

class Notifications {

  constructor (container) {

    this.$container = $(container);
    this.$notifications = this.$container.find('.notifications-content');
    this.$notificationsPagination = this.$container.find('.notifications-pagination');
    this.$settingsBtn = this.$container.find('.notifications-settings-button');

    this.$filters = {
      alerts: {
        name: 'Alerts',
        container: null,
        list: null,
        toggle: null,
      },
      sensors: {
        name: 'Sensors',
        container: null,
        list: null,
        toggle: null,
      },
    };

    this.$filters.sensors.container = this.$container.find('.notifications-filter[data-for="sensors"]');
    this.$filters.sensors.list = this.$filters.sensors.container.find('.notifications-filter-popout-list');
    this.$filters.sensors.toggle = this.$filters.sensors.container.find('.notifications-filter-button');

    this.$filters.alerts.container = this.$container.find('.notifications-filter[data-for="alerts"]');
    this.$filters.alerts.list = this.$filters.alerts.container.find('.notifications-filter-popout-list');
    this.$filters.alerts.toggle = this.$filters.alerts.container.find('.notifications-filter-button');

    this.activeFilter = false;
    this.filtered = {
      sensors: [],
      alerts: [],
    };

    this.alerts = {};
    this.alertsList = [];

    this.notificationCurrentPage = 1;
    this.notificationsPerPage = 10;
    this.notificationTotalPages = 1;

    Promise.all([
      userLoggedIn(),
      this.loadNotifications(),
      this.getAlerts(),
      this.getSensors(),
    ]).then(() => {

      if(maybeBlacklistedOverlay()) {
        return;
      }

      Branding.updateLogo();

      this.renderNotifications();
      this.renderNotificationsPagination();

    });

    this.bindActions();

  }

  getSensors() {
    return new Promise((resolve, reject) => {

      getSensors().then(sensors => {

        sensors = sort(sensors, ['sensor_name']);

        let html = '';

        sensors.forEach(sensor => {
          html += `
          <label>
            <input type="checkbox" class="filter-sensor-id" value="${sensor.id}" /> ${sensor.sensor_name}
          </label>
          `
        });

        this.$filters.sensors.list.html(html);

        resolve();

      });

    });
  }

  getAlerts() {
    return new Promise((resolve, reject) => {

      getAlerts().then(alerts => {

        alerts = sort(alerts, ['alert_name']);

        let html = '';

        alerts.forEach(alert => {
          html += `
          <label>
            <input type="checkbox" class="filter-alert-id" value="${alert.id}" /> ${alert.alert_name}
          </label>
          `
        });

        this.$filters.alerts.list.html(html);

        this.alertsList = alerts;

        alerts.forEach(alert => {
          this.alerts[alert.id] = alert;
        });

        resolve();

      });

    });
  }

  loadNotifications() {

    // loading animation
    this.$notifications.html(`
      <div class="lite-list lite-list--loading">
        <div class="lite-list__header">
          <div class="lite-list__header__col" data-for="time">Time</div>
          <div class="lite-list__header__col" data-for="alert">Alert</div>
          <div class="lite-list__header__col" data-for="sensor">Sensor</div>         
          <div class="lite-list__header__col" data-for="event">Event</div>
          
        </div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
      </div>`
    );

    return new Promise((resolve, reject) => {

      let filters = '';
      let hasFilters = false;

      Object.keys(this.filtered).forEach(key => {

        if(this.filtered[key].length > 0) {
          hasFilters = true;
          filters += `&${key}=${this.filtered[key].join(',')}`;
        }

      });

      window.apiRequest('get', `/user/notifications?page=${this.notificationCurrentPage - 1}${filters}`).then(r => {

        if(r.type === 'success') {

          this.notifications = r.data;
          this.notificationTotalPages = Math.ceil(this.notifications.count / this.notificationsPerPage);

          if(this.notifications.items && this.notifications.items.length > 0) {

            if(this.notificationCurrentPage === 1 && !hasFilters) {

              let lastSeenId = UserNotificationsInstance.getLastSeenId();

              this.notifications.items.forEach(item => {

                const itemId = parseInt(item.id);

                if(lastSeenId < itemId) {
                  lastSeenId = itemId;
                }
              });

              UserNotifications.saveLastSeenId(lastSeenId);
            }

          }
          resolve();
        } else {
          reject();
        }

      });

    });

  }

  renderNotificationsPagination() {

    let html = '';

    const items = this.notifications.items;

    if(items.length > 0) {
      html += `
        <div class="pagination">
          <button class="pagination-item pagination-item--previous ${this.notificationCurrentPage === 1 ? 'disabled' : ''}">
            <i class="far fa-chevron-double-left"></i> Previous
          </button>
      `;

      for(let i = 1; i <= this.notificationTotalPages; i++) {

        if(i === 1 && this.notificationCurrentPage !== 1) {
          html += `<button class="pagination-item pagination-item--page" data-for="1">1</button>`;

          if(this.notificationCurrentPage - 2 > 1) {
            html += `<div class="pagination-item pagination-item--ellipses">...</div>`;
          }

        } else if(i === this.notificationTotalPages && this.notificationTotalPages !== this.notificationCurrentPage) {

          if(this.notificationCurrentPage + 2 < this.notificationTotalPages) {
            html += `<div class="pagination-item pagination-item--ellipses">...</div>`;
          }

          html += `<button class="pagination-item pagination-item--page" data-for="${this.notificationTotalPages}">${this.notificationTotalPages}</button>`;

        } else {

          if (this.notificationCurrentPage === i) {
            html += `<button class="pagination-item pagination-item--current">${i}</button>`;
          } else {
            if (Math.abs(this.notificationCurrentPage - i) < 3) {
              html += `<button class="pagination-item pagination-item--page" data-for="${i}">${i}</button>`;
            }
          }

        }

      }

      html += `
          <button class="pagination-item pagination-item--next ${this.notificationCurrentPage === this.notificationTotalPages ? 'disabled' : ''}">
            Next <i class="far fa-chevron-double-right"></i>
          </button>
        </div>
      `;

    }

    this.$notificationsPagination.html(html);

  }

  renderNotifications() {

    let html = `
    
    <div class="lite-list lite-list--notifications">
    `;

    const items = this.notifications.items;

    if(items.length > 0) {

      html += `
      <div class="lite-list__header">
        <div class="lite-list__header__col" data-for="time">Time</div>
        <div class="lite-list__header__col" data-for="alert">Alert</div>
        <div class="lite-list__header__col" data-for="sensor">Sensor</div>       
        <div class="lite-list__header__col" data-for="event">Event</div>
      </div>
      `;

      items.forEach(item => {

        let event = `${prettyPrintKey(item.event_type)} ${item.event_message}`;

        let event_data = {};

        if(item.event_data) {
          try {
            event_data = JSON.parse(item.event_data.trim());
          } catch (e) {
            console.error(e);
          }
        }

        // Sensor Name: Temperature back below/above Alert_Value (Current_Value)
        if(item.event_type === 'normal') {

          // do the opposite of the condition of the alert
          let alert = this.alerts[item.alert_id];

          if(alert) {

            if(event_data.alert_type === 'dew_point') {

              event = `
                ${prettyPrintKey(event_data.alert_type)} is back to normal)
              `;

            } else {

              event = `
                ${prettyPrintKey(event_data.alert_type)} back ${alert.reading_condition === 'above' ? 'below' : 'above'} ${event_data.alert_value} (${event_data.reading_value})
              `;

            }
          } else {
            event = `
              ${prettyPrintKey(event_data.alert_type)} is back to normal
            `;
          }

        }

        // automatically convert temperature values with numbers
        event = event.replace(/(\d+)\sF/g, '$1&deg;F');
        event = event.replace(/(\d+)\sC/g, '$1&deg;C');

        const created = window.getUserTimezoneDate(item.created);

        let alertName = '';

        if(this.alerts[item.alert_id]) {
          alertName = `
          <a href="${window.site.home}/alerts/edit?id=${item.alert_id}">
            ${this.alerts[item.alert_id].alert_name}
          </a>
          `;
        } else if(item.alert_id != 0) {
          alertName = 'Removed alert';
        } else {
          alertName = 'System Event';
        }

        html += `
        <div class="lite-list__row">
          <div class="lite-list__row__col" data-for="time">
            <span class="lite-list__row-label">Time:</span>
            ${created.format('MMM D, h:mm a')}
          </div>
          <div class="lite-list__row__col" data-for="alert">
            <span class="lite-list__row-label">Alert:</span>
            ${alertName}
          </div>
          <div class="lite-list__row__col" data-for="sensor">
            
            <span class="lite-list__row-label">Sensor:</span>
            ${item.sensor && !isUndefined(item.sensor.sensor_id) ? `
            <a href="${window.site.home}/sensors?id=${item.sensor.sensor_id}">
              ${item.sensor.sensor_name}
            </a>
            ` : 'Deleted sensor'}
            
          </div>
          <div class="lite-list__row__col" data-for="event">
            <span class="lite-list__row-label">Event:</span>
            ${event}
          </div>
          
        </div>`;

      });

    } else {
      html += `
      <div class="lite-list__header">
        <div class="lite-list__header__col" data-for="time">Time</div>
        <div class="lite-list__header__col" data-for="alert">Alert</div>
        <div class="lite-list__header__col" data-for="sensor">Sensor</div>     
        <div class="lite-list__header__col" data-for="event">Event</div>  
      </div>
      <div class="lite-list__row">
        No notifications found
      </div>
      `;
    }

    html += '</div>'; // end .lite-list

    this.$notifications.html(html);

  }

  openSettingsModal() {
    const modal = new Modal({
      class: ['notifications-settings-modal'],
      title: 'Notifications',
    });

    modal.setContent(`
    <p>Download a CSV backup of your sensor notifications</p>
    <button type="button" class="button button--teal" data-for="download-notifications">
      <i class="fas fa-arrow-to-bottom"></i> Download Notifications
    </button>

    <div 
      class="download-progress" 
      style="
        display: none;
        position: relative;
        width: 100%;
        height: 24px;
        margin-top: 1rem;
        background: #e0e0e0;
        border-radius: 4px;
        overflow: hidden;
      "
    >
      <div 
        class="download-progress__bar" 
        style="
          width: 0%;
          height: 100%;
          background: #007bff;
          transition: width 0.2s ease;
        "
      ></div>
      <div 
        class="download-progress__text" 
        style="
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          line-height: 24px;
          font-weight: bold;
          color: #fff;
        "
      >0%</div>
    </div>

    ${!window.currentUser.is_sub_user ? `
      <div class="divider divider--margin-lg"></div>
      <div class="setting">
        <button type="button" class="button button--red" data-for="delete-events">
          <i class="fas fa-trash"></i> Clear Notification History
        </button>
        <div class="setting__description">
          This will <b>permanently delete</b> all of your notification history.
        </div>
      </div>
    ` : ''}
  `);

    const $content          = $(modal.getContentContainer());
    const $downloadBtn      = $content.find('button[data-for="download-notifications"]');
    const $deleteEventsBtn  = $content.find('button[data-for="delete-events"]');
    const $progressContainer = $content.find('.download-progress');
    const $progressBar       = $progressContainer.find('.download-progress__bar');
    const $progressText      = $progressContainer.find('.download-progress__text');

    $deleteEventsBtn.on('click', () => {
      modal.close();
      this.confirmDeleteEventsModal();
    });

    $downloadBtn.on('click', () => {
      $downloadBtn.attr('disabled', true);
      $progressContainer.show();
      $progressBar.css('width', '0%');
      $progressText.text('Downloading (0%)');

      downloadNotifications({
        onProgress: ({ fetched, total }) => {
          const percent = Math.min(100, Math.round((fetched / total) * 100));
          const totalFormatted = total.toLocaleString();
          $progressBar.css('width', percent + '%');
          $progressText.text(`Downloading ${totalFormatted} records (${percent}%)`);
        }
      })
        .then(() => {
          $progressBar.css('width', '100%');
          $progressText.text('Download Complete');
        })
        .catch(() => {
          $progressText.text('Download Failed');
        });
    });

    modal.open();
  }

  confirmDeleteEventsModal() {

    const modal = new Modal({
      class: ['notifications-settings-modal'],
      title: 'Delete All Sensor Notifications',
    });

    modal.setContent(`
    
    ${!window.currentUser.is_sub_user ? `

      <p class="text--bold">Warning! This action will delete the notification history for all of your sensors.</p>
      <p>This action cannot be undone.</p>

      <div class="form-modal-actions">
        <div class="form-modal-actions__submit">
          <button type="button" class="button" style="margin-right: 20px;" data-for="okay" disabled>Delete All Sensor Notifications</button>&nbsp;
          <button type="button" class="button gray" data-for="cancel">Cancel</button>
        </div>
      </div>
     
    ` : ''}
    
    `);

    const $okayBtn = $(modal.getContentContainer()).find('button[data-for="okay"]');
    const $cancelBtn = $(modal.getContentContainer()).find('button[data-for="cancel"]');

    setTimeout(() => {
      $okayBtn.removeAttr('disabled');

      $okayBtn.on('click', () => {

        $(modal.getContentContainer()).addClass('loading-overlay');

        window.apiRequest('post', '/user/notifications/delete/all').then(r => {

          this.loadNotifications().then(() => {
            this.renderNotifications();
            this.renderNotificationsPagination();
            modal.close();
          });

        });

      });

    }, 5000)

    $cancelBtn.on('click', () => {
      modal.close();
    });

    modal.open();

  }

  bindActions() {

    this.$settingsBtn.on('click', this.openSettingsModal.bind(this));

    this.$notificationsPagination.on('click', '.pagination-item--previous', () => {

      if(this.notificationCurrentPage > 1) {

        this.notificationCurrentPage -= 1;

        this.loadNotifications().then(() => {
          this.renderNotifications();
          this.renderNotificationsPagination();
        });

      }

    });

    this.$notificationsPagination.on('click', '.pagination-item--next', () => {

      if(this.notificationCurrentPage < this.notificationTotalPages) {

        this.notificationCurrentPage += 1;

        this.loadNotifications().then(() => {
          this.renderNotifications();
          this.renderNotificationsPagination();
        });

      }

    });

    this.$notificationsPagination.on('click', '.pagination-item--page', e => {

      const $item = $(e.currentTarget);
      const targetPage = parseInt($item.data('for'));

      if(this.notificationCurrentPage !== targetPage) {

        this.notificationCurrentPage = targetPage;

        this.loadNotifications().then(() => {
          this.renderNotifications();
          this.renderNotificationsPagination();
        });

      }

    });

    Object.keys(this.$filters).forEach(type => {

      this.$filters[type].container.find('button[data-for="apply"]').on('click', () => {
        this.applyFilter(type);
      });

      this.$filters[type].container.find('button[data-for="clear"]').on('click', () => {
        this.clearFilter(type);
      });

      this.$filters[type].toggle.on('click', e => {
        this.maybeOpenFilter(type);
      });

    });

  }

  clearFilter(type) {

    this.filtered[type] = [];
    this.$filters[type].container.find('input[type="checkbox"]').prop('checked', false);
    this.$filters[type].container.toggleClass('has-checked', false);

    this.notificationCurrentPage = 1;

    this.loadNotifications().then(() => {
      this.renderNotifications();
      this.renderNotificationsPagination();
    });

    this.closeFilter();

  }

  applyFilter(type) {

    this.filtered[type] = [];

    this.$filters[type].container.find('input[type="checkbox"]').each((i, checkbox) => {

      if($(checkbox).is(':checked')) {
        this.filtered[type].push(checkbox.value);
      }
    });

    if(this.filtered[type].length > 0) {
      this.$filters[type].container.toggleClass('has-checked', true);
    } else {
      this.$filters[type].container.toggleClass('has-checked', false);
    }

    this.notificationCurrentPage = 1;

    this.loadNotifications().then(() => {
      this.renderNotifications();
      this.renderNotificationsPagination();
    });

    this.closeFilter();

  }

  closeFilter() {

    this.$filters[this.activeFilter].container.removeClass('is-active');
    this.$filters[this.activeFilter].toggle.html(`
          <i class="fas fa-filter"></i> ${this.$filters[this.activeFilter].name}
        `);

    this.activeFilter = false;

  }

  maybeOpenFilter(type) {

    if(!this.activeFilter) {

      // no filter, open
      this.activeFilter = type;
      this.$filters[this.activeFilter].container.addClass('is-active');

      this.$filters[this.activeFilter].toggle.html(`
        <i class="far fa-times"></i> ${this.$filters[this.activeFilter].name}
      `);

    } else {

      if(this.activeFilter === type) {

        // filter clicked while open, close
        this.$filters[this.activeFilter].container.removeClass('is-active');
        this.$filters[this.activeFilter].toggle.html(`
          <i class="fas fa-filter"></i> ${this.$filters[this.activeFilter].name}
        `);

        this.activeFilter = false;

      } else {

        // change filter
        this.$filters[this.activeFilter].container.removeClass('is-active');
        this.$filters[this.activeFilter].toggle.html(`
          <i class="fas fa-filter"></i> ${this.$filters[this.activeFilter].name}
        `);

        this.activeFilter = type;
        this.$filters[this.activeFilter].container.addClass('is-active');

        this.$filters[this.activeFilter].toggle.html(`
          <i class="far fa-times"></i> ${this.$filters[this.activeFilter].name}
        `);

      }

    }


  }

}

const notificationsPage = document.querySelector('.notifications-page');

if(notificationsPage) {
  new Notifications(notificationsPage);
}
